import { render, staticRenderFns } from "./GrupKontak.vue?vue&type=template&id=32694e14&scoped=true&"
import script from "./GrupKontak.vue?vue&type=script&lang=js&"
export * from "./GrupKontak.vue?vue&type=script&lang=js&"
import style0 from "./GrupKontak.vue?vue&type=style&index=0&id=32694e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32694e14",
  null
  
)

export default component.exports